export function getMonthName(month: number): string {
  const names = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  if (month < 1 || month > 12) {
    throw new RangeError(`Invalid month number ${month}. Expected 1–12.`);
  }
  return names[month - 1];
}
